import { actions } from './action'

const initialState = {
  modulesHierarchyData: [],
  totalCount: 0,
  pagination: {
    skip: 0,
    limit: 10,
  },
}

const hierarchy = (state = initialState, action) => {
  switch (action.type) {
    case actions.GET_MODULES_HIERARCHY:
      return {
        ...state,
        modulesHierarchyData: action.payload.modulesHierarchyList,
        totalCount: action.payload.totalCount,
      }
    case actions.HANDLE_PAGINATION:
      return {
        ...state,
        pagination: action.payload,
      }
    default:
      return state
  }
}

export default hierarchy
